import { makeRequest } from 'utils/requestLogger';

export default (liveID, status) =>
  makeRequest('put', `/api/live_discussions/${liveID}/toggle_pause`, {
    pause: status,
  });



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/togglePause.js